import { render, staticRenderFns } from "./UserBaseData.vue?vue&type=template&id=7c89b5c4"
import script from "./UserBaseData.vue?vue&type=script&lang=js"
export * from "./UserBaseData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports